// Used in payload interfaces of terms as well as in user profile component to ensure proper strings in methods are used
export enum TermsPayloadKeys {
  Newsletter = 'AcceptMy7nNewsletter',
  EventInvitation = 'AcceptMy7nEventInvitation',
  StoringData = 'AcceptStoringAndSendingDataBy7n'
}
